<template>
  <v-container>
    <v-layout>
      <v-flex xs12 md8 offset-md2>
        <v-alert
          v-if="hasError()"
          :value="true"
          type="error"
        >
          An error has occurred please try again
        </v-alert>
        <v-progress-circular
          v-else
          :size="70"
          :width="7"
          color="primary"
          indeterminate
          class="mt-3 mb-3"
        ></v-progress-circular>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import get from 'lodash/get';

  import { mapActions, mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([ 'getStore' ])
    },
    data() {
      return {
        status: 0
      }
    },
    mounted() {
      this.status = parseInt(get(this.$route, 'query.status', 0), 10)

      if (!this.hasError()) {
        const gid = this.$route.params['gid'];
        const sid = this.$route.params['sid'];
        const tid = this.$route.query['tid'];
        const orderId = this.$route.query['orderId'];
        const displayId = this.$route.query['displayId'];
        this.$router.push({ name: 'menu-selection', params: { gid: gid, sid: sid, restaurantSlug: this.getStore.slug }, query: { tid: tid, orderId, displayId } })
        this.setSuccessfulOrderDialog(true)
        this.resetCart()
      }
    },
    methods: {
      ...mapActions([ 'resetCart', 'setSuccessfulOrderDialog' ]),
      hasError() {
        return !(this.status === 2 || this.status === 3)
      }
    }
  };
</script>
